import styles from "./StatusPageConsumption.module.scss";

interface ConsumptionNotFoundProps {
  title?: string;
  message?: string;
}

// Full-page "not found" state shared across the consumption pages, so a missing status
// page or component renders a clear message instead of a stuck spinner.
export const ConsumptionNotFound = ({
  title = "Status Page Not Found",
  message = "The status page you are looking for does not exist or is not publicly accessible.",
}: ConsumptionNotFoundProps) => (
  <div className={styles.pageWrapper}>
    <div className={styles.errorContainer}>
      <h2 className="pulseTextH1Bold">{title}</h2>
      <p className="pulseTextBody">{message}</p>
    </div>
  </div>
);
